/* eslint-disable prettier/prettier */
/** @jsxImportSource @emotion/react */
import { useDispatch, useSelector } from 'react-redux';
import { selectCartHasEmergencyCheckoutWarningMessage } from 'cart-ui-react/src/autoshipState/selectors';
import { setCartWarningMessage } from 'cart-ui-react/src/autoshipState/autoshipSlice';
import Xbutton from './Xbutton';
import t from '@rcm/i18n-client';

const CheckoutWarningModal = () => {
  const dispatch = useDispatch();
  const warningMessage = useSelector(selectCartHasEmergencyCheckoutWarningMessage);


  const handleOkay = () => {
    dispatch(setCartWarningMessage(''));
    localStorage.removeItem('paymentError');
  };

  return warningMessage ? (
    <div
      css={{
        backgroundColor: '#c2e9f6',
        color: '#007ca4',
        width: '100%',
        minHeight: '50px',
        border: '1px solid #00a4e4',
        borderRadius: '4px',
        margin: '16px auto 0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'nowrap',
        padding: '0 4px',
        ['p']: { margin: 0, whiteSpace: 'pre-wrap' },
      }}
    >
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          margin: 'auto',
          width: '-webkit-fill-available',
          padding: '20px',
          position: 'sticky',
          top: 0,
        }}
      >
        <p>
          {t(warningMessage)}
        </p>
      </div>
      <Xbutton sx={{ width: '22px' }} onClick={handleOkay} />
    </div>
  ) : null;
};

export default CheckoutWarningModal;
